<template>
  <div :key="video.id">
    <span
      class="block mb-2 rounded relative overflow-hidden group cursor-pointer"
      @click="showModal=true"
    >
      <div class="group-hover:text-primary-500 group-hover:bg-opacity-50 bg-opacity-25 transition absolute inset-0 text-white bg-gray-900 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16" viewBox="0 0 24 24">
          <path class="opacity-10 group-hover:fill-primary-500 group-hover:opacity-100 transition" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" fill="white" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
        </svg>
      </div>

      <div v-if="video.duration" class="absolute text-sm leading-none font-bold text-white bg-gray-900 bottom-2 right-2 rounded p-1.5 px-2">{{ duration }}</div>

      <img loading="lazy" class="w-full" :src="video.thumbnail" width="1280" height="720" :alt="video.title">

    </span>
    <div>
      <slot />
    </div>
    <bc-modal variant="video" v-model="showModal" :header="video.title">
          <div class="bg-gray-900 text-white aspect-video w-full overflow-hidden rounded">
            <vue-plyr ref="plyr" :options="options">
              <div data-plyr-provider="vimeo" :data-plyr-embed-id="video.source"></div>
            </vue-plyr>
          </div>
    </bc-modal>
  </div>
</template>

<script>

export default {
  name: 'VideoPlayer',
  props: {
    video:{
      type: Object,
      required: true
    },
  },
  data() {
    return {
      options: {
        autoplay: true,
        vimeo: { byline: false, portrait: false, title: false, speed: false, transparent: false },
      },
      showModal: false
    }
  },
  computed: {
    duration() {
      const x = this.video.duration * 1000
      var dur = this.$moment.duration(this.video.duration, 'seconds');
      var hours = Math.floor(dur.asHours());
      var mins  = Math.floor(dur.asMinutes()) - hours * 60;
      var sec   = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;
      return ((hours > 0) ? (hours+":") : '') + ((mins > 9) ? mins : ("0"+mins)) + ":" + ((sec > 9) ? sec : ("0"+sec));
    }
  },
  methods: {
    leading_zeros(t) {
      return (t < 10 ? '0' : '') + t;
    },
    PlayVideo ({ params, cancel }) {
      //this.$refs.plyr.player.play()
      this.$refs.plyr.player.on('ready', (event) => {
         // event.detail.plyr.currentTime = 100
        // event.detail.plyr.play()
        console.log('player.ready')
      });

    }
  }
}
</script>
